import React from 'react';
import { withTranslation, WithTranslation, Trans } from 'react-i18next';
import { URLS } from '@wix/da-url';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import FavouriteOutfilled from '@wix/da-ds/pkg/Icons/FavouriteOutfilled/FavouriteOutfilled';
import { BiData, SubmitButtonClickBiEvent } from '@wix/da-bi/pkg/events';

import EmptyState from '../../../EmptyState';
import { GallectionType } from '../../../../../types/gallection';
import s from './GallectionsEmptyState.scss';

const TRANSLATION_KEYS = {
  [GallectionType.GALLERY]: {
    titleOwner: 'pages.gallections.gallery.emptyState.title.owner',
    titleVisitor: 'pages.gallections.gallery.emptyState.title.visitor',
    subtitleOwner: 'pages.gallections.gallery.emptyState.subtitle.owner',
    subtitleVisitor: 'pages.gallections.gallery.emptyState.subtitle.visitor',
    buttonCTA: 'pages.gallections.gallery.emptyState.buttonCTA.owner',
  },
  [GallectionType.COLLECTION]: {
    titleOwner: 'pages.gallections.collection.emptyState.title.owner',
    titleVisitor: 'pages.gallections.collection.emptyState.title.visitor',
    subtitleOwner: 'pages.gallections.collection.emptyState.subtitle.owner',
    subtitleVisitor: 'pages.gallections.collection.emptyState.subtitle.visitor',
    buttonCTA: 'pages.gallections.collection.emptyState.buttonCTA.owner',
  },
};

export interface Props {
  gallectionType: GallectionType;
  ownerUsername: string;
  isOwner: boolean;
  isUplift?: boolean;
}

export class GallectionsEmptyState extends React.Component<
  Props & WithTranslation
> {
  render() {
    const { isOwner, t, gallectionType, ownerUsername, isUplift } = this.props;

    return (
      <EmptyState
        view="large"
        className={s['root']}
        title={
          isOwner
            ? t(TRANSLATION_KEYS[gallectionType].titleOwner)
            : t(TRANSLATION_KEYS[gallectionType].titleVisitor, {
                username: ownerUsername,
              })
        }
        subtitle={this.getSubtitle()}
        buttonVariant={
          gallectionType === GallectionType.GALLERY && isUplift
            ? 'approval-green'
            : undefined
        }
        buttonLabel={
          isOwner ? t(TRANSLATION_KEYS[gallectionType].buttonCTA) : undefined
        }
        biData={BiData<SubmitButtonClickBiEvent>({
          evid: 704,
          sectionname: gallectionType,
        })}
        onButtonClick={isOwner ? this.onButtonClick : undefined}
        withButton={isOwner}
      />
    );
  }

  onButtonClick = () => {
    if (this.props.gallectionType === GallectionType.GALLERY) {
      this.navigateToSubmit();
    } else {
      this.navigateToBrowse();
    }
  };

  navigateToSubmit() {
    window.location.replace(URLS.SUBMIT);
  }

  navigateToBrowse() {
    window.location.replace(URLS.ROOT);
  }

  getSubtitle() {
    const { isOwner, gallectionType, t, ownerUsername } = this.props;
    if (isOwner) {
      return gallectionType === GallectionType.COLLECTION ? (
        <>
          {/* prettier-ignore */}
          <Trans i18nKey={TRANSLATION_KEYS[gallectionType].subtitleOwner}>
            Simply star{' '}
            <FavouriteOutfilled
              size={IconSize.SMALL}
              className={s['star']}
            />{' '}
            your favourite deviations as you browse, to show other deviants what you love.
          </Trans>
        </>
      ) : (
        t(TRANSLATION_KEYS[gallectionType].subtitleOwner)
      );
    }

    return t(TRANSLATION_KEYS[gallectionType].subtitleVisitor, {
      username: ownerUsername,
    });
  }
}

export default withTranslation()(GallectionsEmptyState);
